/**
 * @generated SignedSource<<36214a12a4badaa690c979368697f50e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceContainerSecondary_viewer$data = {
  readonly isWordpressArticlesEnabled: boolean | null;
  readonly itemRead: ReadonlyArray<{
    readonly internalBuyLinks?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
    } | null> | null;
    readonly seller?: {
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerInformation_seller">;
    } | null;
    readonly serviceId?: string | null;
    readonly storyTellingModule?: {
      readonly tabs: ReadonlyArray<{
        readonly supplementaryEditorial: {
          readonly articles: ReadonlyArray<{
            readonly __typename: "WordpressArticleType";
          }> | null;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerInformation_item" | "PdpSharedEditorialArticles_refactor_item" | "PdpSharedSellerItemsCarousel_item" | "PdpSharedVisuallySimilarItemsCarouselLazy_item" | "SharedRespLinksBlock_item">;
  } | null> | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplacePersonalizedCarouselLazy_user" | "PdpRespSellerInformation_user" | "PdpSharedFeaturedRelatedItemsCarouselLazy_user" | "PdpSharedSellerItemsCarousel_user" | "PdpSharedVisuallySimilarItemsCarouselLazy_user" | "PdpSharedYMALItemsCarousel_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplacePersonalizedCarouselLazy_viewer" | "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer" | "PdpSharedSellerItemsCarousel_viewer" | "PdpSharedVisuallySimilarItemsCarouselLazy_viewer" | "PdpSharedYMALItemsCarousel_viewer" | "SharedRespLinksBlock_viewer">;
  readonly " $fragmentType": "PdpRespMarketplaceContainerSecondary_viewer";
};
export type PdpRespMarketplaceContainerSecondary_viewer$key = {
  readonly " $data"?: PdpRespMarketplaceContainerSecondary_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceContainerSecondary_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplayAndNotBot"
    },
    {
      "kind": "RootArgument",
      "name": "fetchSellerReviewsSection"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceContainerSecondary_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedYMALItemsCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedVisuallySimilarItemsCarouselLazy_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespMarketplacePersonalizedCarouselLazy_viewer"
    },
    {
      "condition": "afterDisplayAndNotBot",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer"
        }
      ]
    },
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "WP_EDITORIAL"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedYMALItemsCarousel_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedSellerItemsCarousel_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedVisuallySimilarItemsCarouselLazy_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespMarketplacePersonalizedCarouselLazy_user"
            },
            {
              "condition": "afterDisplayAndNotBot",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_user"
                }
              ]
            },
            {
              "condition": "fetchSellerReviewsSection",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSellerInformation_user"
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "InternalBuyLinkType",
              "kind": "LinkedField",
              "name": "internalBuyLinks",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SharedRespLinksBlock_links"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "shortTitles",
                  "value": true
                }
              ],
              "concreteType": "StoryTellingModule",
              "kind": "LinkedField",
              "name": "storyTellingModule",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoryTellingTab",
                  "kind": "LinkedField",
                  "name": "tabs",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "WordpressArticlesType",
                      "kind": "LinkedField",
                      "name": "supplementaryEditorial",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WordpressArticleType",
                          "kind": "LinkedField",
                          "name": "articles",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "storyTellingModule(shortTitles:true)"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Seller",
              "kind": "LinkedField",
              "name": "seller",
              "plural": false,
              "selections": [
                {
                  "condition": "fetchSellerReviewsSection",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSellerInformation_seller"
                    }
                  ]
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedRespLinksBlock_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedSellerItemsCarousel_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedEditorialArticles_refactor_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedVisuallySimilarItemsCarouselLazy_item"
            },
            {
              "condition": "fetchSellerReviewsSection",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSellerInformation_item"
                }
              ]
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "81c2f9ad62cdc135fd253af1d1c181ad";

export default node;
